import { useMemo } from "react";

import { useRootSessionThreadInputs } from "../rootSessionStripContainer";
import {
  projectSessionLivenessRollups,
  projectWorldLivenessRollups,
  type SessionLivenessNode,
  type SessionLivenessRollup,
  type WorldLivenessRollups,
} from "./worldLiveness";

/**
 * Live per-World rollups for the World rail. Sessions keep running when their
 * World is backgrounded — a World is a filter over threads, not a runtime
 * boundary — and their status keeps streaming into the shell atom; this is the
 * one place that reads that atom UNfiltered so backgrounded work can reach its
 * door.
 */
export function useWorldLivenessRollups(): WorldLivenessRollups {
  const threads = useRootSessionThreadInputs();
  return useMemo(() => projectWorldLivenessRollups(threads), [threads]);
}

/** Live per-Session rollups for one World's Session tab rows. */
export function useSessionLivenessRollups(
  worldKey: string | null,
  sessions: ReadonlyArray<SessionLivenessNode>,
): ReadonlyMap<string, SessionLivenessRollup> {
  const threads = useRootSessionThreadInputs();
  return useMemo(
    () =>
      worldKey === null
        ? new Map<string, SessionLivenessRollup>()
        : projectSessionLivenessRollups({ worldKey, sessions, threads }),
    [sessions, threads, worldKey],
  );
}
